module.exports = __webpack_public_path__ + "static/img/vipavatar.2cf676e6.svg";